import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { usePaperworkContextBookingId } from '~/routes/paperwork/PaperworkBookingIdContext';

export const useAccountMatchesBooking = () => {
  const bookingId = usePaperworkContextBookingId();
  const accountSummary = useSelector((state) => state.account.summary);
  const booking = useSelector((state) => state.pastBookings[bookingId] || {});
  //If logged in, return whether the account id matches the account id on the booking
  if (!isEmpty(accountSummary) && !isEmpty(booking)) {
    return accountSummary?.id === (booking.account_id ?? booking.accountId);
  }
  return true;
};
